import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { addYears } from "date-fns";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PpsUtilityService } from "../services/pps-utility.service";
import { IDateRange } from "./models/date-range";

@Component({
  selector: "pps-data-range-form",
  templateUrl: "./date-range-form.component.html"
})
export class DateRangeFormComponent implements OnInit{
  options = {
    showFromDate: true,
    showToDate: true,
    showPresetDateRange: true,
    fromDateLabel: "From",
    toDateLabel: "To",
    presetDateRangeLabel: "Select Date Range",
    minToDate: addYears(new Date(), -100),
    maxToDate: addYears(new Date(), 100),
    prompt: null,
    promptStyleClasses: ""
  };

  private initialValues = {
    presetDateRange: "today",
    fromDate: this._util.getDateOnly(new Date()),
    toDate: this._util.getDateOnly(new Date())
  };

  mdClasses = {
    presetDateRange: "p-md-6",
    fromDate: "p-md-3",
    toDate: "p-md-3"
  };

  message = "";
  dateRange: IDateRange = {
    range: {
      from: this._util.getDateOnly(new Date()),
      to: this._util.getDateOnly(new Date())
    } 
  };
  yearRange: string = "";

  public dateRanges: {id:string, title: string}[] = [];
  public selectedDateRange: {id:string, title: string} = null;

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService) {
    this.setData(this._dlgConfig.data);
  }

  ngOnInit(): void {
    let dateRanges = this._util.getDateRanges();
    this.dateRanges = Object.keys(dateRanges).map(key => { return {id: key, title: dateRanges[key].title}; });
    this.yearRange = `2018:${addYears(new Date(), 5).getFullYear()}`;

    // this.selectedDateRange = this.dateRanges.filter(dt => dt.title === "Today")[0];
    // this.setDateRange();
    this.initialize();
  }

  onDateRangeChanged(event){
    this.setDateRange();
  }

  private setData(data: any){
    if (!data){
      return;
    }

    this.options = Object.assign(this.options, data.options);
    this.initialValues = Object.assign(this.initialValues, data.initialValues);

    if (this.options.showPresetDateRange){
      this.options.showFromDate = this.options.showToDate = true;
    }else{
      if (this.options.showFromDate && this.options.showToDate){
        this.mdClasses.fromDate = this.mdClasses.toDate = "p-md-6";
      }else{
        this.mdClasses.fromDate = this.mdClasses.toDate = "p-md-12";
      }
    }
  }

  private initialize(){
    if (this.initialValues.presetDateRange){
      let ranges = this.dateRanges.filter(dt => dt.title.toLowerCase() === this.initialValues.presetDateRange?.toLowerCase());
      if (ranges.length > 0){
        this.selectedDateRange = ranges.length > 0 ? ranges[0] : null;  
      }
    }

    this.setDateRange();
  }

  private setDateRange(){
    if (this.selectedDateRange){
      let range = this._util.getDateRange(this.selectedDateRange.id);
      if (range){
        this.dateRange.range.from = range.from;
        this.dateRange.range.to = range.to;
      }
    }else{
      this.dateRange.range.from = this.initialValues.fromDate;
      this.dateRange.range.to = this.initialValues.toDate;
    }
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    if (this.options.showFromDate && this.options.showToDate && this.dateRange.range.from > this.dateRange.range.to){
      this.message = "From date must be earlier than To date";
      return;
    }

    this._dialogRef.close(this.dateRange);
  }

  cancel(){
    this._dialogRef.close();
  }  
}